var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: _vm.id,
        "aria-labelledby": _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
        "data-ob1-component": "Popin",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content pb-0 px-1 px-md-2" }, [
          _c("div", [
            _c(
              "div",
              { staticClass: "modal-header" },
              [
                _vm.activeView !== "intro"
                  ? _c("Lien", {
                      attrs: {
                        id: "back-button",
                        "is-button": true,
                        "is-mini": true,
                        "is-link-arrow-back": true,
                        label: "Retour",
                      },
                      on: { click: _vm.goBack },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-close ob1-link-arrow back d-none",
                    attrs: { type: "button", "data-bs-dismiss": "modal" },
                  },
                  [
                    _vm._v(
                      "\n                        Fermer\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body px-0" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 px-2 px-md-3 px-lg-5" },
                  [
                    _c("page-loading-spinner", {
                      staticClass: "over-page-loading-spinner",
                      attrs: { "is-refresh-loading": _vm.isRefreshLoading },
                    }),
                    _vm._v(" "),
                    _c("DiscountPopinIntroShared", {
                      attrs: {
                        "active-view": _vm.activeView,
                        dto: _vm.dto,
                        "emit-add-offer-click":
                          _vm.isOffersMode && !_vm.dto.introContent.fromCart,
                        "enable-continue-without-discount":
                          _vm.isOffersMode && !_vm.dto.introContent.fromCart,
                      },
                      on: {
                        "update:activeView": function ($event) {
                          _vm.activeView = $event
                        },
                        "add-offer-click": _vm.onIntroAddOfferClick,
                        "continue-without-discount-click":
                          _vm.onIntroContinueWithoutDiscountClick,
                      },
                    }),
                    _vm._v(" "),
                    _c("DiscountPopinFormShared", {
                      attrs: {
                        "active-view": _vm.activeView,
                        dto: _vm.dto,
                        "phone-line-value": _vm.phoneLineValue,
                        "phone-line-error-message": _vm.phoneLineErrorMessage,
                        "customer-code-value": _vm.customerCodeValue,
                        "customer-code-error-message":
                          _vm.customerCodeErrorMessage,
                        "show-alert-message": _vm.showAlertMessage,
                      },
                      on: {
                        "update:activeView": function ($event) {
                          _vm.activeView = $event
                        },
                        "update:phoneLineValue": function ($event) {
                          _vm.phoneLineValue = $event
                        },
                        "update:phoneLineErrorMessage": function ($event) {
                          _vm.phoneLineErrorMessage = $event
                        },
                        "update:customerCodeValue": function ($event) {
                          _vm.customerCodeValue = $event
                        },
                        "update:customerCodeErrorMessage": function ($event) {
                          _vm.customerCodeErrorMessage = $event
                        },
                        "update:showAlertMessage": function ($event) {
                          _vm.showAlertMessage = $event
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("DiscountPopinInfoShared", {
                      attrs: { "active-view": _vm.activeView, dto: _vm.dto },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "sticky-bottom py-4 px-3 bg-white modal-footer d-flex justify-content-center",
              },
              [
                _vm.activeView === "form"
                  ? _c("Bouton", {
                      staticClass: "w-100 mw-100 w-sm-auto",
                      attrs: {
                        id: "valid-form",
                        "is-button": true,
                        "is-primary": true,
                        label: _vm.dto.formContent.formButton.label,
                        href: "#",
                        "tms-category":
                          _vm.dto.formContent.formButton.tms.category,
                        "tms-action": _vm.dto.formContent.formButton.tms.action,
                        "tms-label":
                          _vm.labelForResult(_vm.submissionResultType) ||
                          _vm.dto.formContent.formButton.tms.label,
                      },
                      on: { click: _vm.onAddSponsorPid },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn-close pt-2 pt-md-0 d-block",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Fermer",
        },
      },
      [
        _c("span", {
          staticClass: "icon icon-delete",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }